const routes = {
    home: '/',
    favorite: '/favorite',
    movies: '/movies/',
    shows: '/shows',
    comedy: '/comedy',
    musicVideo: '/musicVideo',
    other: '/other',
    movie: '/movie/:nickname',
};

export default routes;
